import React from 'react';
import Button from 'airbnb-dls-web/build/exp/Button';
import Column from 'airbnb-dls-web/build/exp/Column';
import ColumnRow from 'airbnb-dls-web/build/exp/ColumnRow';
import { withStyles, withStylesPropTypes } from 'airbnb-dls-web/build/themes/withStyles';
import Rule from 'airbnb-dls-web/build/exp/Rule';
import Spacing from 'airbnb-dls-web/build/exp/Spacing';
import Text from 'airbnb-dls-web/build/exp/Text';
import Title from 'airbnb-dls-web/build/exp/Title';
import Event from './Event';

const propTypes = {
  ...withStylesPropTypes,
};

function TechTalks({ techTalkList }) {
   // To handle the case where the teck talks array is empty. However, this is
   // unlikely to happen in Airbnb.
  if (!techTalkList || !techTalkList.length) {
    return null;
  }

  // Pick all up coming events as promoted events
  const today = new Date();
  const todayTimeStamp = today.getTime();
  const promotedTechTalks = techTalkList
    .filter(talk => Date.parse(talk.date) >= todayTimeStamp)
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  // TODO: Ideally, we should promote all upcoming events. But we only promote
  // the first one for now. Change is expected in the future.
  const promotedTechTalk = promotedTechTalks[0];

  // Only show the tech talks
  // 1) after a specific timestamp 'Jan 1, 2016'
  // 2) with event or image link, for some reason, the vidoe link doesn't show screenshot anymore
  const timestampForLeastRecentTalk = Date.parse('Jan 1, 2016');
  const otherTechTalks = techTalkList
    .slice(promotedTechTalks.length)
    .filter(talk => Date.parse(talk.date) >= timestampForLeastRecentTalk)
    .filter(talk => !!talk.eventLink || !!talk.imageLink)

  return (
    <Spacing top={3} left={3} right={3}>
      {
        promotedTechTalks.length == 0 ? null :
        (<Spacing>
            <Spacing top={5} bottom={2} left={2} >
              <Title level={2}>Upcoming Events</Title>
            </Spacing>
            <Event event={promotedTechTalk} eventType="promoted" />
            <Spacing top={5} left={2}>
              <Spacing top={1}>
                <Title level={3}>{ promotedTechTalk.title }</Title>
              </Spacing>
              <Spacing top={1}>
                <Text light>
                {
                  new Date(promotedTechTalk.date).toLocaleString([],
                    {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: '2-digit'
                    }
                  )
                }
                </Text>
              </Spacing>
              {
                !promotedTechTalk.location ? null :
                (
                  <Spacing top={1}>
                    <Text light>{ promotedTechTalk.location }</Text>
                  </Spacing>
                )
              }
              <Spacing top={2}>
                <Button href={ promotedTechTalk.eventLink } openInNewWindow>RSVP</Button>
              </Spacing>
            </Spacing>
          </Spacing>)
      }
      <Spacing top={10} left={2} right={2}>
        <Title level={2}>Past Events</Title>
        <Rule />
      </Spacing>
      <Spacing top={3} left={2} right={2}>
        <ColumnRow>
          {otherTechTalks.map(event =>
            (<Column sm={12} md={4} key={event.title} >
              <Event event={ event } eventType="others" />
              <Rule />
            </Column>),
          )}
        </ColumnRow>
      </Spacing>
    </Spacing>
  );
}

Event.propTypes = propTypes;

export default withStyles(({ color }) => ({
  tagsCopy: {
    color: color.core.babu,
  },
}))(TechTalks);



// WEBPACK FOOTER //
// ./src/components/TechTalks.jsx